<div class="container">
  <div class="block">
    <div class="block-title">ArrowButtonComponent from ArrowButtonModule</div>
    <div class="block-directory">
      src/app/new-core/components/buttons-game/arrow-button/arrow-button.component.ts
    </div>
    <div class="block-content">
      <div class="line">
        <ms-arrow-button direction="left"></ms-arrow-button>
        <ms-arrow-button></ms-arrow-button>
      </div>

      <div class="line">
        <ms-arrow-button size="medium" direction="left"></ms-arrow-button>
        <ms-arrow-button size="medium" direction="right"></ms-arrow-button>
      </div>
    </div>
  </div>

  <div class="block">
    <div class="block-title">BackgroundButtonComponent from BackgroundButtonModule</div>
    <div class="block-directory">
      src/app/new-core/components/buttons-game/background-button/background-button.component.ts
    </div>
    <div class="block-content">
      <div class="line">
        <ms-background-button></ms-background-button>
        <ms-background-button icon="color"></ms-background-button>
      </div>

      <div class="line">
        <ms-background-button size="medium" icon="image"></ms-background-button>
        <ms-background-button size="medium" icon="color"></ms-background-button>
      </div>

      <div class="line">
        <ms-background-button size="small" icon="image"></ms-background-button>
        <ms-background-button size="small" icon="color"></ms-background-button>
      </div>
    </div>
  </div>

  <div class="block">
    <div class="block-title">ButtonIconSmComponent from ButtonIconSmModule</div>
    <div class="block-directory">
      src/app/new-core/components/buttons-game/button-icon-sm/button-icon-sm.component.ts
    </div>
    <div class="block-content">
      <div class="line">
        <ms-button-icon-sm type="minus"></ms-button-icon-sm>
        <ms-button-icon-sm type="plus"></ms-button-icon-sm>
        <ms-button-icon-sm type="play"></ms-button-icon-sm>
        <ms-button-icon-sm type="stop"></ms-button-icon-sm>
        <ms-button-icon-sm type="pause"></ms-button-icon-sm>
      </div>
    </div>
  </div>

  <div class="block">
    <div class="block-title">IconButtonComponent from IconButtonModule</div>
    <div class="block-directory">
      src/app/new-core/components/buttons-game/icon-button/icon-button.component.ts
    </div>
    <div class="block-content">
      <div class="line">
        <ms-icon-button type="setting"></ms-icon-button>
        <ms-icon-button type="history"></ms-icon-button>
        <ms-icon-button type="background"></ms-icon-button>
      </div>
    </div>
  </div>

  <div class="block">
    <div class="block-title">GameButtonComponent from GameButtonModule</div>
    <div class="block-directory">
      src/app/new-core/components/buttons-game/game-button/game-button.component.ts
    </div>
    <div class="block-content">
      <div class="line">
        <button msGameButton="next"></button>
        <button msGameButton="answer"></button>
        <button msGameButton="stop"></button>
        <button msGameButton="stop">Остановить</button>
        <button msGameButton>Запомнил</button>
      </div>
    </div>
  </div>

  <div class="block">
    <div class="block-title">PlayButtonComponent from PlayButtonModule</div>
    <div class="block-directory">
      src/app/new-core/components/buttons-game/play-button/play-button.component.ts
    </div>
    <div class="block-content">
      <div class="line">
        <ms-play-button></ms-play-button>
        <ms-play-button size="medium"></ms-play-button>
        <ms-play-button size="extraMedium"></ms-play-button>
        <ms-play-button size="small"></ms-play-button>
        <ms-play-button size="extraSmall"></ms-play-button>
      </div>
    </div>
  </div>
</div>
